import React, { useEffect, useState } from 'react'
import { useAppState } from 'store'
import { Route, Switch, useHistory, useLocation } from 'react-router-dom'
import { PublicRoute, PrivateRoute } from '../../components/Route'
import { pages } from '../../pages/pages'

/* Components */
import AppLayout from './AppLayout'

/* Pages */
import HomePage from 'pages/Home'
import SignUpPage from 'pages/SignUp'
import AboutPage from 'pages/About'
import HowItWorksPage from 'pages/HowItWorks'
import NewsPage from 'pages/News'
import NotFoundPage from 'pages/PageNotFound'
import PricingPage from 'pages/Pricing'
import FacilitiesPage from 'pages/Facilities'
import ClientListPage from 'pages/ClientList'
import EmailOutreachPage from 'pages/EmailOutreach'
import TextOutreachPage from 'pages/TextOutreach'
import Program from 'pages/Program'
import WaiverSignees from 'pages/WaiverSignees'
import FacilityOperations from 'pages/FacilityOperations'
import DiscardedAppointment from 'pages/DiscardedAppointment'
import FacilityVisitor from 'pages/FacilityVisitor'
import ProfilePage from 'pages/Profile'
import ClientProfile from 'pages/ClientProfile'
import ExternalProgramPage from 'pages/ExternalProgram'
import MyFacilityPage from 'pages/MyFacility'
import PublicProgramPage from 'pages/PublicProgram'
import SignInModal from 'components/SignInModal'
import FacilityBookNow from 'pages/FacilityBookNow'
import ReportsPage from 'pages/Reports'
import CreateClientPage from 'pages/CreateClient/CreateClient.page'
import { setToken } from 'services/tokenManager'

const AppModule: React.FC = () => {
  const location = useLocation()
  const { push } = useHistory()
  const token = useAppState(state => state.auth.token)
  const isLogged = useAppState(state => state.auth.isLogged)
  const isFacilityOwnerUser = useAppState(
    state => state.auth.user?.facility_owner
  )

  const [openSignInModal, setOpenSignInModal] = useState<boolean>(false)

  const toggleModal = () => {
    setOpenSignInModal(!openSignInModal)
  }

  useEffect(() => {
    if (location && location.pathname) {
      const path = location.pathname
      const pathname = path.substring(path.lastIndexOf('/') + 1)

      if (pathname.includes('reservations') && !isLogged) {
        toggleModal()
        push('/')
      }

      // if (
      //   path.includes('locations') &&
      //   !isNaN(+pathname) &&
      //   isLogged &&
      //   !isFacilityOwnerUser
      // ) {
      //   push(`${path}/reservations`)
      // }

      if (pathname.includes('week_view')) {
        const newPath = path.replace('week_view', 'reservations')
        push(newPath)
      }
    }
  }, [location])

  useEffect(() => {
    if (token) {
      setToken(token)
    }
  }, [token])

  return (
    <AppLayout>
      <Switch>
        <PublicRoute path={pages.Home.path} exact>
          <HomePage />
          {openSignInModal && <SignInModal onModalClose={toggleModal} />}
        </PublicRoute>
        <PublicRoute path={pages.SignUp.path} exact>
          <SignUpPage />
        </PublicRoute>
        <PublicRoute path={pages.About.path} exact>
          <AboutPage />
        </PublicRoute>
        <PublicRoute path={pages.HowItWorks.path} exact>
          <HowItWorksPage />
        </PublicRoute>
        <PublicRoute path={pages.News.path} exact>
          <NewsPage />
        </PublicRoute>
        <PublicRoute path={pages.Pricing.path} exact>
          <PricingPage />
        </PublicRoute>
        <PublicRoute path={pages.FacilityVisitor.path} exact>
          <FacilityVisitor />
        </PublicRoute>
        <PrivateRoute path={pages.FacilityBookNow.path} exact>
          <FacilityBookNow />
        </PrivateRoute>
        <PrivateRoute path={pages.Profile.path} exact>
          <ProfilePage />
        </PrivateRoute>
        <PrivateRoute path={pages.Facilities.path} exact>
          <FacilitiesPage />
        </PrivateRoute>
        <PrivateRoute path={pages.Reports.path} exact>
          <ReportsPage />
        </PrivateRoute>
        <PrivateRoute path={pages.CreateClients.path} exact>
          <CreateClientPage />
        </PrivateRoute>
        <PrivateRoute
          path={pages.ExternalProgram.path}
          skipIsFacilityOwner
          exact>
          <ExternalProgramPage />
        </PrivateRoute>
        <PrivateRoute path={pages.ClientProfile.path} exact>
          <ClientProfile />
        </PrivateRoute>
        <PrivateRoute path={pages.Clientlist.path} exact>
          <ClientListPage />
        </PrivateRoute>
        <PrivateRoute path={pages.EmailOutreach.path} exact>
          <EmailOutreachPage />
        </PrivateRoute>
        <PrivateRoute path={pages.TextOutreach.path} exact>
          <TextOutreachPage />
        </PrivateRoute>
        <PrivateRoute path={pages.Programs.path} exact>
          <Program />
        </PrivateRoute>
        <PrivateRoute path={pages.WaiverSignees.path} exact>
          <WaiverSignees />
        </PrivateRoute>
        <PrivateRoute path={pages.FacilityOperations.path} exact>
          <FacilityOperations />
        </PrivateRoute>
        <PrivateRoute path={pages.DiscardedAppointment.path} exact>
          <DiscardedAppointment />
        </PrivateRoute>
        <PrivateRoute path={pages.MyFacility.path} exact>
          <MyFacilityPage />
        </PrivateRoute>
        <PrivateRoute path={pages.PublicProgram.path} exact>
          <PublicProgramPage />
        </PrivateRoute>
        <Route>
          <NotFoundPage />
        </Route>
      </Switch>
    </AppLayout>
  )
}

export default AppModule
